import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noiseSourceDisplay',
  standalone: true,
})
export class NoiseSourceDisplayPipe implements PipeTransform {
  transform(value: string | string[] | null | undefined): string {
    if (!value) return '';
    if (Array.isArray(value)) {
      return value
        .map((v) => this.formatSingle(v))
        .filter(Boolean)
        .join(', ');
    }
    return this.formatSingle(value);
  }

  private formatSingle(value: string): string {
    if (!value) return '';
    const key = value.toLowerCase().trim();

    switch (key) {
      case 'rail_transit':
        return 'Lignes ferroviaires et gares';
      case 'bus_transit':
        return 'Transports en commun (réseau de bus)';
      case 'commercial_activity':
        return 'Commerces et activités de proximité';
      case 'industrial_activity':
        return 'Activités industrielles (ICPE)';
      case 'road_traffic':
        return 'Trafic routier et axes de circulation';
      case 'air_traffic':
        return 'Couloir aérien et aérodrome';
      case 'urban_activity':
        return 'Activités urbaines animées';
      case 'highway':
        return 'Autoroute ou voie rapide';
      case 'rail':
        return 'Lignes ferroviaires';
      case 'shops':
        return 'Commerces et services';
      case 'industry':
        return 'Installations industrielles';
      default: {
        const cleaned = key.replace(/_/g, ' ');
        return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
      }
    }
  }
}
